import React, { useState, useMemo, useEffect } from "react";
import { CardComp, ButtonComp } from "../../../components";
import { formatMoney } from "../../../utils";
import moment from "moment";

const PAGE_SIZE = 5;

const ContributionEntriesModal = ({
  type = "contribution",
  categoryName = "",
  total = 0,
  entries = [],
  onClose,
}) => {
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil((entries?.length || 0) / PAGE_SIZE) || 1;

  // Reset to page 1 when entries change
  useEffect(() => {
    setPage(1);
  }, [entries.length]);

  const paginatedEntries = useMemo(() => {
    const start = (page - 1) * PAGE_SIZE;
    return entries.slice(start, start + PAGE_SIZE);
  }, [entries, page]);
  return (
    <div className="px-3 px-lg-4 py-4">
      <div className="d-flex justify-content-between align-items-start mb-4">
        <div>
          <p className="text-muted text-uppercase mb-1" style={{ fontSize: 12 }}>
            {type === "savings" ? "Savings Category" : "Contribution Category"}
          </p>
          <h5 className="fw-bold text-dark mb-1">{categoryName}</h5>
          <p className="text-muted mb-0" style={{ fontSize: 14 }}>
            Total Amount: {formatMoney(total || 0)}
          </p>
        </div>
        <button
          type="button"
          className="btn btn-sm p-2"
          onClick={onClose}
          style={{
            border: "none",
            backgroundColor: "transparent",
            color: "var(--color-primary)",
            fontSize: "20px",
            cursor: "pointer",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "var(--color-primary-soft)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          <i className="fas fa-times"></i>
        </button>
      </div>

      {entries && entries.length > 0 ? (
        <>
          <div className="d-flex flex-column gap-3">
            {paginatedEntries.map((entry) => (
              <CardComp
                key={entry.id ?? `${entry.reference}-${entry.payment_date}`}
                cardClassName="border shadow-sm"
              >
                <div className="p-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="mb-0 fw-bold" style={{ fontSize: 15 }}>
                      {formatMoney(entry.amount || 0)}
                    </h6>
                    <span className="text-muted" style={{ fontSize: 13 }}>
                      {entry.payment_date
                        ? moment(entry.payment_date).format("DD MMM, YYYY · hh:mm A")
                        : "N/A"}
                    </span>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <p className="text-muted mb-1 small">Payment Method</p>
                      <p className="mb-0">{entry.payment_method || 'N/A'}</p>
                    </div>
                    <div className="col-md-4">
                      <p className="text-muted mb-1 small">Recorded By</p>
                      <p className="mb-0">
                        {entry.recorded_by?.name || entry.recorded_by?.email || "Member"}
                      </p>
                    </div>
                    <div className="col-md-4">
                      <p className="text-muted mb-1 small">Reference</p>
                      <p className="mb-0">{entry.reference || "N/A"}</p>
                    </div>
                  </div>
                </div>
              </CardComp>
            ))}
          </div>
          {totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
              <ButtonComp
                btnText="Previous"
                disabled={page === 1}
                btnClassName="btn btn-outline-secondary btn-sm"
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              />
              <span className="text-muted small fw-semibold">
                Page {page} of {totalPages}
              </span>
              <ButtonComp
                btnText="Next"
                disabled={page === totalPages}
                btnClassName="btn btn-outline-secondary btn-sm"
                onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
              />
            </div>
          )}
          {totalPages === 1 && entries.length > 0 && (
            <div className="text-center mt-3 pt-3 border-top">
              <span className="text-muted small">
                Showing {entries.length} {entries.length === 1 ? 'entry' : 'entries'}
              </span>
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-5">
          <img
            src="/Images/empty-state.svg"
            alt="No data"
            style={{ width: "120px", marginBottom: "16px", opacity: 0.6 }}
          />
          <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
            No payment history found for this category.
          </p>
        </div>
      )}
    </div>
  );
};

export default ContributionEntriesModal;

